import { ListItemButton } from "@mui/material"

export function GuidanceOption({ item, current, setCurrent }) {
    return (
        <ListItemButton
            data-cy="reference-option"
            className="guidance-item"
            selected={current === item}
            onClick={() => setCurrent(item)}
        >
            {item.HTML}
        </ListItemButton>
    )
}
